/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserIdListModel
 */
export interface UserIdListModel {
    /**
     * 
     * @type {Array<number>}
     * @memberof UserIdListModel
     */
    users: Array<number>;
}

export function UserIdListModelFromJSON(json: any): UserIdListModel {
    return UserIdListModelFromJSONTyped(json, false);
}

export function UserIdListModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserIdListModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'users': json['users'],
    };
}

export function UserIdListModelToJSON(value?: UserIdListModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'users': value.users,
    };
}

